<template>
  <!-- 唉 搞什么通顶，APP不做 H5做 唉 -->
    <!-- 顶部 -->
  <!-- 表单基础区 -->
  <div :class="`complaint-container ${isSearchTitle ? '' : 'unsupport-hidehead-container' }`" >
    <div :class="`page-header ${isSearchTitle ? '' : 'unsupport-hidehead' }`">
      <z-fix-top
        keep-position
        class="fixtop"
        v-if="isSearchTitle"
      >
        <z-nav-bar
          class="navbar"
          left-arrow
          @click-left="handleClickLeft"
          title="投诉中心"
        >
        </z-nav-bar>
      </z-fix-top>
      <p class="complaint-header-tip">请填写以下问题，以便我们更好的为您服务！</p>
    </div>
    <!-- <div :class="`wrappers ${isSearchTitle ? '' : 'wrappers-unsupport' }`"> -->
      <div class="complaint-form" ref="complaintForm">

      <!-- 是否订单问题选择区 -->
      <div class="iforder-select-group">
        <div class="iforder-select-header">
          <div class="iforder-select-header-title">是否为订单问题</div>
          <div
            class="iforder-select-header-changeText"
            v-show="hasOrderSelect === 1"
            @click="resetOrderSelect"
          >
            修改
          </div>
        </div>
        <!-- 是否tag的渲染 -->
        <div class="iforder-select-btn-group" v-if="hasOrderSelect === 0">
          <div
            class="iforder-select-btn"
            @click="handleOrderButtonClick(1)"
            :class="{ active: isOrder === 1 }"
          >
            <span>是</span>
          </div>
          <div
            class="iforder-select-btn"
            @click="handleOrderButtonClick(2)"
            :class="{ active: isOrder === 2 }"
          >
            <span>否</span>
          </div>
        </div>
        <!-- 如果已经选中了是否为订单问题，展示对应文案 -->
        <div class="iforder-selected-span" v-else>
          <span>{{ isOrder === 1 ? '是' : '否' }}</span>
        </div>
      </div>
      <!-- 订单详情展示区域 -->
      <div class="order-detail-info-area" v-if="isOrder === 1">
        <div class="order-detail-info-area-header">
          <div class="order-detail-info-area-header-title">选择投诉订单</div>
          <div class="order-detail-info-area-header-change" v-show="orderId" @click="changeOrderItem">
            修改
          </div>
        </div>
        <div class="order-detail-info-area-container">
          <!--选中订单展示-->
          <div v-if="isOrder===1 && orderId">
            <order-detail-info :item="orderItem" />
          </div>
          <div v-else class="order-detail-info-area-container-add-order-btn" @click="showOrderList">
            <span>点击添加</span>
          </div>
        </div>
      </div>
      <!-- 问题分类选择区 -->
      <div class="question-info-area" v-if="isOrder === 2 || (isOrder === 1 && orderId)">
        <div class="question-info-area-header">
          <div class="question-info-area-header-title">问题类型</div>
          <div class="question-info-area-header-change" v-show="questionTypeId" @click="showQuestionList">修改</div>
        </div>
        <div class="question-info-area-container">
          <!-- 选中的问题类型 -->
          <div v-if="questionTypeId" class="question-info-area-container-question"><span>{{quetionTypeLabel}}</span></div>
          <!--问题类型选择-->
          <div v-else class="question-info-area-container-add-order-btn" @click="changeQuestionItem"><span>点击添加</span></div>
        </div>
      </div>
      <!-- 表单提交区 -->
      <div class="action-form-info-area">
        <action-form :isOrder="isOrder" :questionTypeId="questionTypeId" :orderId="orderId" :orderItem="orderItem" :questionTypeItem="questionTypeItem" @scrollUpFormConHeight="scrollUpFormConHeight"></action-form>
      </div>
      <!-- 订单列表弹窗 -->
      <z-popup position="bottom" height="80vh" class="z-action-picker" v-model="orderListModalVisble" :show-btn="false">
        <!--订单下拉选择-->
        <order-pick-list @selectOrder="selectOrderItem" @handleClose="actionClose" />
      </z-popup>
      <!--问题类型弹窗-->
      <z-action-picker title="选择问题类型" height="80vh" class="z-action-picker" v-model="questionTypeListModalVisble" :show-btn="false">
        <question-select-list :orderId="orderId" :orderItem="orderItem" @onQuestionTypeChange="onQuestionTypeChange" @handleCloseQuestionList="handleCloseQuestionList"></question-select-list>
      </z-action-picker>
      <!--用户服务进度状态展示-->
        <tip-popup
          :feedBackStatus="feedBackStatus"
          :feedBackMsg="feedBackMsg"
          :showPopup="showPopup"
          :isNew="isNew"
          @togglePopup="togglePopup"
          :orderId="orderId"
          :faqId="questionTypeId"
        />
      </div>
    <!-- </div> -->
  </div>
</template>

<script>
import native from '@zz-common/native-adapter'
import {
  ActionPicker,
  FixTop,
  NavBar,
  Popup
} from '@zz-common/zz-ui'
import { getCookie, isZlj, hideShareButton, RAFMove } from '../../../lib/utils'
import { checkUserComplainStatus } from '../../../api/resourceApi'
import OrderPickList from '../components/order-pick-list'
import TipPopup from '../components/tip-popup-new'
import OrderDetailInfo from '../components/order-detail-info'
import QuestionSelectList from '../components/quesition-select-list'
import ActionForm from '../components/action-form'

export default {
  name: 'ComplaintForm',
  components: {
    OrderPickList,
    TipPopup,
    OrderDetailInfo,
    QuestionSelectList,
    ActionForm,
    'z-action-picker': ActionPicker,
    'z-fix-top': FixTop,
    'z-nav-bar': NavBar,
    'z-popup': Popup
  },
  data() {
    return {
      // uid
      uid: getCookie('uid'),
      // APP种类
      clientType: isZlj() ? 2 : 1,
      // 平台
      platform: native.client || 'zz',
      // 是否为订单问题, 默认为0不展示，1为是，2为否
      isOrder: 0,
      // 是否进行了“订单问题”的状态
      hasOrderSelect: 0,
      // 订单列表弹窗是否开启
      orderListModalVisble: false,
      // 选中的订单信息
      orderItem: {},
      // 选中的订单ID
      orderId: '',
      // 问题分类弹窗是否开启
      questionTypeListModalVisble: false,
      // 选中的问题分类
      questionTypeId: '',
      // 选中的问题分类名称
      quetionTypeLabel: '',
      questionTypeItem: {},
      bannerSrc: require('../../../assets/img/complaint_new_banner.png'),
      //
      showPopup: false, // 是否有服务单检查提示弹窗flag
      isNew: true, // 标识是否为新反馈问题
      feedBackStatus: '0',
      feedBackMsg: '',
      isSearchTitle: false, // 是否支持顶部穿透
      clientY: 0,
      bsScrollRef: null
    }
  },
  created() {
    hideShareButton()
    native.setTitle({
      title: '投诉中心'
    })
    native.wrap('isStatusBarSupportTransparent')((res) => {
      console.log('SDK端测试 res', res)
      if (res.support === '1') {
        this.isSearchTitle = true
      } else {
        console.log('此手机不支持 statusBar 穿透')
        this.isSearchTitle = false
      }
    })
    this.isNew = true
    this.handleCheckStatus()
  },
  computed: {
  },
  mounted() {
    // console.log('bsScroll', bsScroll)
    // eslint-disable-next-line new-cap
    // this.bsScrollRef = new bsScroll(this.$refs.wrapper)
    console.log('this.bsScrollRef', this.bsScrollRef)
    document.body.addEventListener('touchmove', function(e) {
      if (e.touches[0].clientY > this.clientY) {
        const el = document.querySelector('html')
        const { scrollTop, clientHeight, scrollHeight } = el
        if (scrollTop + clientHeight > scrollHeight) {
          this.clientY = e.touches[0].clientY
          e.preventDefault();
          e.stopPropagation();
        }
      }
    }, { passive: false });
  },
  methods: {
    // goBack
    handleClickLeft() {
      native.goBack()
    },
    // 是否为订单问题
    handleOrderButtonClick(status) {
      // this.isOrder = status
      this.hasOrderSelect = 1
      if (Number(status) !== Number(this.isOrder)) {
        this.isOrder = status
        this.orderItem = {}
        this.orderId = ''
        this.questionTypeId = ''
        this.quetionTypeLabel = ''
        this.questionTypeItem = {}
      }
    },
    // 清空是否为订单问题的选项
    resetOrderSelect() {
      // 清空是否进行过订单问题的记录
      this.hasOrderSelect = 0
      // 滞空选择过的订单ID和订单信息
      // this.orderItem = {}
      // this.orderId = ''
      // this.questionTypeId = ''
      // this.quetionTypeLabel = ''
      // this.questionTypeItem = {}
    },
    // 弹起订单列表的半层
    showOrderList() {
      this.orderListModalVisble = true
    },
    // 透传给订单列表组件的选择订单的方法
    selectOrderItem(item) {
      // 获取选定的订单信息
      console.log('complain-select-order', item)
      this.orderItem = item
      const { id = '', orderId = '' } = this.orderItem || {}
      this.orderId = id || orderId
      this.orderListModalVisble = false
      this.handleCheckStatus()
    },
    // 订单列表组件关闭方法
    actionClose() {
      this.orderListModalVisble = false
    },
    // 锚定具体订单
    changeOrderItem() {
      // this.orderId = ''
      // this.orderItem = {}
      this.orderListModalVisble = true
      this.questionTypeId = ''
      this.quetionTypeLabel = ''
      this.questionTypeItem = {}
    },
    // 唤起问题分类弹窗
    changeQuestionItem() {
      this.questionTypeListModalVisble = true
    },
    showQuestionList() {
      this.questionTypeListModalVisble = true
    },
    // 问题分类选择回调
    onQuestionTypeChange(val) {
      console.log('当前选择的问题实例是', val)
      this.questionTypeListModalVisble = false
      const { name = '', id = '' } = val || {}
      if (!id) {
        console.log('异常')
      } else {
        this.questionTypeItem = val
        this.quetionTypeLabel = name
        this.questionTypeId = id
        this.handleCheckStatus()
        const { isC2CFakeDliverFaq = 0, isOtherC2CSpecialFaq = 0 } = val
        if (!isC2CFakeDliverFaq) this.easeInScrollMove(500)
        if (isOtherC2CSpecialFaq) this.easeInScrollMove(500, 400)
      }
    },

    easeInScrollMove(duration, finalTop = 0) {
      const formContainer = document.querySelector('.complaint-form')
      const baseHeight = formContainer.scrollTop
      const totalHeight = formContainer.scrollHeight
      const aimHeight = (finalTop || totalHeight) - baseHeight
      console.log('这是什么啊', baseHeight, totalHeight, aimHeight)
      RAFMove(
        (process) => {
          formContainer.scrollTop =
              baseHeight + parseInt(aimHeight * process * process)
        },
        () => {
          // 到达滚动设置时间后直接到底部
          formContainer.scrollTop = finalTop || totalHeight
        },
        duration
      )
    },

    scrollUpFormConHeight() {
      console.log('祖辈组件')
      this.easeInScrollMove(500, 500)
    },

    //
    togglePopup(val) { // 提示窗显隐
      this.showPopup = val
    },
    // 检测状态
    handleCheckStatus() {
      // created/mounted阶段，
      if (!this.isOrder) {
        this.checkUserStatus({
          uid: this.uid,
          clientType: this.clientType
        })
      } else {
        if (!this.orderId && this.questionTypeId) {
          this.checkUserStatus({
            uid: this.uid,
            clientType: this.clientType,
            faqId: this.questionTypeId
          })
        } else if (this.orderId && this.questionTypeId) {
          const businessType = this.orderItem?.businessType || ''
          this.checkUserStatus({
            uid: this.uid,
            clientType: this.clientType,
            orderId: this.orderId,
            faqId: this.questionTypeId,
            businessType
          })
        } else if (this.orderId && !this.questionTypeId) { // 选择订单/更改订单时检查
          const businessType = this.orderItem?.businessType || ''
          this.checkUserStatus({
            uid: this.uid,
            clientType: this.clientType,
            orderId: this.orderId,
            businessType
          })
        }
      }
    },
    async checkUserStatus(params) { // 判断账户状态
      const res = await checkUserComplainStatus(params)
      console.log('getComplainInfo', res)
      const { status, msg = '' } = res
      if (msg !== '') {
        this.showPopup = true
        this.feedBackMsg = msg
        this.feedBackStatus = status
      }
    },
    handleCloseQuestionList() {
      this.questionTypeListModalVisble = false
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
